import { render, staticRenderFns } from "./InvestmentAccountTypeChangeSlots.vue?vue&type=template&id=1bd8d2f2"
import script from "./InvestmentAccountTypeChangeSlots.vue?vue&type=script&lang=ts"
export * from "./InvestmentAccountTypeChangeSlots.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports